import React from 'react';
import EventCard from './EventCard';
import { events } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const EventsSection = ({ selectedEvents, onToggleEvent }) => {
  return (
    <section 
      id="events" 
      className="py-12 bg-gradient-to-b from-white via-green-50/20 to-white"
      aria-labelledby="events-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 
            id="events-heading"
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4"
          >
            Choose Your <span className="text-green-800">IWD Events</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select the events that resonate with your organization's goals. 
            Each experience is designed to create lasting impact and meaningful change.
          </p>
          
          {/* Selection Counter */}
          {selectedEvents.length > 0 && (
            <div className="mt-6 inline-flex items-center gap-2 bg-green-800 text-white px-6 py-3 rounded-full font-bold shadow-lg">
              <span>{selectedEvents.length} event{selectedEvents.length !== 1 ? 's' : ''} selected</span>
            </div>
          )}
        </div>

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {events.map((event) => (
            <EventCard
              key={event.id}
              event={event}
              isSelected={selectedEvents.includes(event.id)}
              onToggleSelect={onToggleEvent}
            />
          ))}
        </div>

        {/* Bottom CTA */}
        {selectedEvents.length > 0 && (
          <div className="mt-12 text-center">
            <button
              onClick={() => {
                const element = document.getElementById('enquiry');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-3 bg-green-800 hover:bg-green-900 text-white px-10 py-5 rounded-2xl font-bold text-lg shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1"
            >
              Proceed with {selectedEvents.length} Selected Event{selectedEvents.length !== 1 ? 's' : ''}
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default EventsSection;
